import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_array_includes, assert_type_number } from '@shared/asserts/utils_asserts';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  value: number;
  key: keyof STATE__ui;
}

export const LOCAL__ui_set_number = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_SET_NUMBER,
  payload,
});

export function INIT_LOCAL__ui_set_number(state: STATE__ui, action: PayloadAction<Payload>) {
  let { key, value } = action.payload;

  let value_old = state[key];

  assert_type_number(value);
  assert_array_includes(['undefined', 'number'], typeof value_old, { key, assert_type: ENUM__error_type.VALIDATION_INVALID_TYPE });

  (state as any)[key] = value;
}
